import { CSSResultGroup, html, LitElement, nothing, TemplateResult } from 'lit'
import { customElement } from 'lit/decorators.js'
import { consume } from '@lit/context'
import { quotationActionErrorContext } from 'components/ordering/quotation/components/context/quotation-context.js'
import { QuotationError } from 'components/ordering/quotation/api/dtos/error.js'
import { hostDisplayContents } from 'components/ordering/quotation/components/quotation.style.js'


@customElement('csc-quotation-error-banner')
export class CSCQuotationErrorBanner extends LitElement {
  static override styles: CSSResultGroup = [hostDisplayContents]

  @consume({ context: quotationActionErrorContext, subscribe: true })
  private actionError!: QuotationError | null

  protected override render(): TemplateResult | typeof nothing {
    if (!this.actionError) return nothing

    return html`
      <cse-alert variant="error">
        ${this.actionError.message}
      </cse-alert>
    `
  }
}
